import { useState, useEffect } from 'react';

interface IToggleButton {
  id: string;
  label: string;
  value: string;
  onChange: (fieldName: string, value: string | number) => void;
  showLabel?: boolean;
  required?: boolean;
  hidden?: boolean;
  options?: Array<{
    id: string;
    label: string;
    value: string;
  }>;
}

export const ToggleButton = ({
  id,
  label,
  value,
  onChange,
  hidden = false,
  options,
}: IToggleButton): JSX.Element => {
  const opts = Array.isArray(options) ? options : [];
  const [isToggled, setIsToggled] = useState(false);

  useEffect(() => {
    // Set initial state based on value
    if (opts?.length >= 2 && opts[1]) {
      setIsToggled(value === opts[1].value);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value, options]);

  const handleToggle = () => {
    const newToggleState = !isToggled;
    setIsToggled(newToggleState);

    if (opts?.length >= 2 && opts[0] && opts[1]) {
      const newValue = newToggleState ? opts[1].value : opts[0].value;
      onChange(id, newValue);
    }
  };

  if (hidden) return <></>;

  const leftOption = opts[0] || { label: 'No', value: 'no' };
  const rightOption = opts[1] || { label: 'Yes', value: 'yes' };

  return (
    <div className="sm:pb-4">
      <div className="flex gap-6 items-center">
        <span className="text-xs font-normal text-gray-900 leading-6">
          {label}
        </span>

        <div className="flex gap-3 items-center">
          <img
            src={
              isToggled
                ? 'https://assets.clear.in/cleartax/images/1761417820_togglebutton.png'
                : 'https://assets.clear.in/cleartax/images/1761417875_togglebutton1.png'
            }
            alt="Toggle button"
            className="cursor-pointer w-8 h-8"
            onClick={handleToggle}
          />

          <span className="text-xs">
            {isToggled ? rightOption.label : leftOption.label}
          </span>
        </div>
      </div>
    </div>
  );
};
